module.exports = __webpack_public_path__ + "img/202211-xl.988ec2a8.png";